module.exports = __webpack_public_path__ + "static/media/basic.d5c8cf8c.jpg";